module.exports = __webpack_public_path__ + "img/youtube.49aee0bc.svg";